import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PortfolioManagement from './pages/PortfolioManagement';
import ContactInfo from './pages/ContactInfo';
import WebsiteContent from './pages/WebsiteContent';
import Leads from './pages/Leads';
import MediaManager from './pages/MediaManager';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';

const AdminApp = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="dashboard" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="portfolio" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<PortfolioManagement />} />
          </Route>
          <Route path="contact-settings" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<ContactInfo />} />
          </Route>
          <Route path="website-content" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<WebsiteContent />} />
          </Route>
          <Route path="leads" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Leads />} />
          </Route>
          <Route path="media" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<MediaManager />} />
          </Route>
          <Route path="settings" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Settings />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default AdminApp;
